import Home from "./home/home";
import Benefits from "../../../components/cards/benefits";
import Testimonials from "../../../components/cards/testimonials";
import OurMission from "./sections/ourMission";
import OurServices from "./sections/ourServices";
import NavBar from "../../../components/navbar/navbar";
import CTAHome from "../../../components/cta/CTAHome";
import Footer from "../../../components/footer/footer";


function LandingPage() {
    return (
        <>
            <NavBar />
            <div className="bg-[#fafafa]">
                <Home />
                <OurServices />
                <OurMission />
                <Benefits />
                <Testimonials />
                <CTAHome />
            </div>
            <Footer />
        </>
    )
}
export default LandingPage